import debounce from "lodash.debounce";
import { useState } from "react";
import { useSearchBox } from "react-instantsearch";
import { Form, FormField, FormGroup, Input, Label } from "semantic-ui-react";
import sidekickLogo from "../../images/sidekick-logo-75x79.png";

const CallTranscriptionSearchBox = (props) => {
  const { query, refine } = useSearchBox(props);
  const [inputValue, setInputValue] = useState(query);

  const debouncedSetQuery = debounce((oldQuery, newQuery) => {
    refine(newQuery);
  }, 300);

  function setQuery(newQuery) {
    const oldQuery = inputValue;
    setInputValue(newQuery);
    debouncedSetQuery(oldQuery, newQuery);
  }

  return (
    <Form style={{ width: "100%" }}>
      <FormGroup inline style={{ width: "100%" }}>
        <FormField style={{ width: "100%" }}>
          <Input
            style={{ width: "100%" }}
            aria-label="Search"
            autoCapitalize="off"
            autoComplete="off"
            autoCorrect="off"
            autoFocus
            maxLength={255}
            onChange={(event) => setQuery(event.currentTarget.value)}
            placeholder="Search extension, phone number, transcription content etc"
            spellCheck={false}
            type="search"
            value={inputValue}
            name="search"
            labelPosition="left"
          >
            <Label
              image
              style={{
                paddingRight: "0",
                background: "none",
                borderTop: "1px solid #767676",
                borderLeft: "1px solid #767676",
                borderBottom: "1px solid #767676",
              }}
            >
              <img
                src={sidekickLogo}
                alt="Sidekick logo"
                style={{ padding: "4px 0px 4px 10px" }}
              />
            </Label>
            <input
              style={{
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                borderLeft: "none",
              }}
            />
          </Input>
        </FormField>
      </FormGroup>
    </Form>
  );
};

export default CallTranscriptionSearchBox;
